<template lang="pug">
    Modal
        .form
            h2  Add a New Localized Content Record to Card
            .form__control-group
                label Assign a new market and local record to this action card
                multiselect.locale-picker(
                    v-model="newLocale"
                    :options="getMarketsByLocale"
                    searchable="false"
                    :selectLabel="''"
                    :searchable="false"
                    :allow-empty="false"
                    :deselectLabel="''"
                    :multiple="false"
                )
            .form__control-group.copy-content
                label
                    input(
                        type="checkbox"
                        v-model="isCopying"
                    )
                    | &nbsp; Check here to copy content from another market
                div(
                    v-if="isCopying"
                )
                    label Copy Content from...
                    multiselect(
                        v-model="copiedLocale"
                        :options="getSortedAvailableLocales"
                        :searchable="false"
                        :selectLabel="''"
                        :allow-empty="false"
                        :deselectLabel="''"
                        :multiple="false"
                    )
            button.button__submit(
                @click="submit"
            ) Add Locale Record To Card
</template>
<script>
import Modal from '../general/Modal';
import store from '../../store';
import Services from '../../services/Services';
import { postResource } from '../../services/Utils.js';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import VueNotifications from 'vue-notifications';
export default {
    name: 'CreateLocalRecord',
    components: {
        Modal,
        Multiselect,
    },
    data() {
        return {
            newLocale: '',
            isCopying: false,
            copiedLocale: ''
        }
    },
    computed: {
        getActiveCard() {
            return store.getters.getActiveCard;
        },
        getSortedAvailableLocales(){
            if (this.getActiveCard && this.getActiveCard.localRecords) {
                let locales = [];

                this.getActiveCard.localRecords.forEach(locale => {
                    // lol?
                    locales.push(locale.locale);
                });

                return locales.sort((a, b) => a.name - b.name).reverse();
            }
        },
        getAvailableMarkets() {
            return store.getters.getMarkets;
        },
        getMarketsByLocale() {
            if (this.getAvailableMarkets) {
                let marketsByLocale = [];

                this.getAvailableMarkets.forEach(market => {
                marketsByLocale.push(market.locale);
                });

                return marketsByLocale;
            }
        },
    },
    notifications: {
        showSuccessMsg: {
        type: VueNotifications.types.success,
        title: '',
        icon: '✅'
        },
        showErrorMsg: {
        type: VueNotifications.types.error,
        title: '',
        icon: '❗️'
        }
    },
    mounted(){
        Services.getMarkets();
    },
    methods: {
        submit(){
            const newRecord = {
                recordId: this.getActiveCard._id,
                recordType: 'ActionCard',
                locale: this.newLocale
            }

            if(this.isCopying) {
                newRecord.copiedLocale = this.copiedLocale;
            }

            postResource('/v1/actioncards/addLocalRecord', false, newRecord)
                .then(res => {
                    console.log('success!', res);
                    this.showSuccessMsg({ message: `New ${this.newLocale} record added to ${this.getActiveCard.displayName}!` });
                    store.commit('hideModals', true);
                    Services.setActiveCard(this.getActiveCard._id, this.locale, this.$router.push(`/cards/${this.getActiveCard._id}`));
                    return res;
                })
                .catch(error => {
                    let message = 'An error occurred. Please try again.';
                    if(error.error){
                        message = error.error;
                    }
                    this.showErrorMsg({
                    message
                    });
                });
        }
    }
}
</script>
<style lang="scss" scoped>
h2 {
    text-align: center;
}

.form {
    padding: 2rem;
}

.form__control-group.rule__control-group--select:after {
    top: 20px;
}

button {
    margin: 2rem auto 0;
}

.copy-content {
    margin-top: 20px;

    div {
        margin-top: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/CreateCardLocalRecord.vue